// extracted by mini-css-extract-plugin
export default {"newchat-main":"NewChat_newchat-main__IgYSN","text-section":"NewChat_text-section__NIsuS","gradientAnimation":"NewChat_gradientAnimation__Zltng"};